@use "~theme/typography";
@use "~theme/breakpoints";

.header {
    display: block;
    overflow: auto;
    padding: 20px;
    @include breakpoints.desktop {
        margin: 0px;
        padding: 0px;
    }
}

.container {
    display: block;
    @include breakpoints.desktop {        
        margin: 10px 6% 60px;
        display: block;
        overflow: auto;
    }
}

.containerNew {
    display: block;
    width: 100%;

    @include breakpoints.desktop {
        max-width: calc(var(--max-desktop-width) + (2 * var(--card-gutter-width)));
        margin: 0 auto;
    }
}

.headerImage {
    float: left;
    width: 65px;
}

.headerText {
    font-style: normal;
    font-weight: 600;
    display: flex;
    align-items: center;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--pure-black);
    float: left;
    font-size: 16px;
    line-height: 140%;
    margin-right: 5px;
    @include breakpoints.desktop {        
        font-size: 24px;
        line-height: 150%;
        margin-top: 10px;
    }
}

.imageCircle {
    width: 34px;
    height: 34px;
    @include breakpoints.desktop {
        width: 56px;
        height: 56px;
    }
}

.imageTick {
    position: relative;
    left: -25px;
    top: -5px;
    width: 25px;
    @include breakpoints.desktop {
        width:auto;        
        position: relative;
        left: 15px;
        top: -48px;
    }
}

.content {    
    margin-top: 20px;
    display: block;
    overflow: auto;
    overflow-x: hidden;
    @include breakpoints.desktop {
        margin-top: 0px;
        overflow: initial;
    }
    @include breakpoints.desktop-medium {
        margin-top: 40px;
        overflow: initial;
    }
    @include breakpoints.desktop-large {
        margin-top: 40px;
        overflow: initial;
    }
}

.contentBox {
    background: var(--white);
    box-shadow: none;
    padding: 0px;
    height: 150px;
    float: left;
    margin: 0px;
    width: 100%;
    height: auto;
    @include breakpoints.desktop {
        height: 150px;
        width: 46%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
      @include breakpoints.desktop-medium {
        height: 150px;
        width: 47%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
      @include breakpoints.desktop-large {
        height: 150px;
        width: 47%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
}

.line {
    width: 100%;
    height: 0px;
    border: 1px solid var(--gray-06);
    display: none;
    overflow: auto;
    @include breakpoints.desktop {
        display: block;
    }
}

.borderDivider {
    border: 1px solid rgba(0, 51, 102, 0.3);
    display: block;
    overflow: hidden;
    @include breakpoints.desktop {
        display: none;
    }
}

.buttonContainer {
    button {
        border: 2px solid var(--blue-01);
        width: 90%;
        letter-spacing: 0.12em;
        font-size: 20px;
        @include breakpoints.desktop {
            width: 100%;
            font-size: 1.125rem;
        }
    }
}

.wantAnother {
    padding: 10px;
}

.footer {
    display: block;
    overflow: auto;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
    @include breakpoints.desktop {
        margin-top: 10px;
    }
}

.saveDisk {
    margin-right: 5px;
    margin-top: -5px;
}
.confirmContainer {
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0.02em;
    padding: 0px 20px;
    @include breakpoints.desktop {
        font-size: 14px;
        padding: 0px;
    }
}


.contentLeft {
    width: 15%;
    float: left;
    .avatar {
        margin-left: 0px;
        @include breakpoints.desktop {
            margin-left: 8px;
        }
    }
    @include breakpoints.desktop {
        width: 20%;
    }
    @include breakpoints.desktop-medium {
        width: 15%;
    }
    @include breakpoints.desktop-large {
        width: 15%;
    }
  }
  
.contentRight {
    width: 80%;
    float: left;
    margin-left: 12px;
    @include breakpoints.desktop {
        width:80%;
        margin-left: 0px;
    }
}

.avatar3Heads {
    margin-left: -20px;
    @include breakpoints.desktop {
        margin-left: -10px;
    }
}
.doctorPadding {
    padding: 20px 25px !important;
    @include breakpoints.desktop {
        padding: 20px !important;
    }
    @include breakpoints.desktop-medium {
        padding: 20px 25px !important;
    }
    @include breakpoints.desktop-large {
        padding: 20px 25px !important;
    }
}

.doctorName {
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--black);
    padding: 10px 0px;
    @include breakpoints.desktop {
        font-size: 18px;
        line-height: 100%;
    }
    @include breakpoints.desktop-medium {
        font-size: 20px;
    }
    @include breakpoints.desktop-large {
        font-size: 20px;
    }
}

.timeSlot {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--black);
    display: none;
    @include breakpoints.desktop {
        display: block;
        font-size: 18px;
        line-height: 100%;
    }
    @include breakpoints.desktop-medium {
        display: block;
        font-size: 20px;
        line-height: 150%;
    }
    @include breakpoints.desktop-large {
        display: block;
        font-size: 20px;
        line-height: 150%;
    }
}
.timeSlotMobile {
    float: left;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--black);
    display: block;
    @include breakpoints.desktop {
        display: none;
    }
}
.officeImg {
    width: 62px;
    height: 60px;
    margin-left: -5px;
    @include breakpoints.desktop {
        width: initial;
        height: initial;
        margin-left: 0px;
    }
}
.officeName {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--black);
    @include breakpoints.desktop {
        font-size: 20px;
        line-height: 150%;
        letter-spacing: 0.12em;
    }
}

.officeAddress {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: var(--black);
    @include breakpoints.desktop {
        font-size: 16px;
    }
}

.patientMobile {
    padding: 10px 25px !important;
    @include breakpoints.desktop {
        padding: 0px;
        height: auto !important;
    }
}

.patientName {
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--black);
    padding-bottom: 5px;
}

.patientInfo {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0.02em;
    color: var(--black);
    padding-bottom: 5px;
    inline-size: 110%;
    overflow-wrap: anywhere;
    word-break: break-word;
    @include breakpoints.desktop {
        inline-size: initial;
    }
}

.patientProfile {
    padding: 5% 0px;
    @include breakpoints.desktop {
        padding-left: 10px;
    }
    img {
        width:35px;
        height: 35px;
        @include breakpoints.desktop {
            width: auto;
            height: auto;
        }
    }
}

.patientInfoPadding {
   padding: 18px 0px;
}

.saveTime {
    font-weight: 600;
    font-size: 15px;
    line-height: 150%;
    text-align: left;
    letter-spacing: 0.12em;
    text-transform: uppercase; 
    color: var(--black);
    margin-bottom: 30px;
    height: 40px;
    @include breakpoints.desktop {
        height: auto;
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
    }
}

.saveTimeIcon {
    width: 30px;
    margin-left: 7px;
    @include breakpoints.desktop {
        width: auto;
        margin-left: 0px;
    }
}

.checkButton {
    button {
        font-weight: 400;
        font-size: 20px;
        line-height: 150%;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--white);        
        width: 90%;
        left: 5%;
        position: absolute;
        right: 20px;
        @include breakpoints.desktop {
            width:95%;
            position: initial;
            left: 0px;
            right: 0px;
            font-size: 18px;
        }
    }
}

.checkInPad {
    padding: 20px 25px;
    height: 140px;
    @include breakpoints.desktop {
        padding: 3% 0 2% 2%;
        height: 150px;
    }
}


.contentBoxV2 {
    background: var(--white);
    box-shadow: none;
    padding: 0px;
    height: 150px;
    float: left;
    margin: 0px;
    width: 100%;
    height: auto;
    @include breakpoints.desktop {
        height: 150px;
        width: 100%;
        margin: 15px 0px;
        background: var(--gray-05);
        border-radius: 8px;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
      }
}

.insCheck {
    margin: 0 var(--card-gutter-width);
}

.formContainer {
    @include breakpoints.desktop {
        margin: 0;
    }
}

.contentLeftV2 {
    width: 15%;
    float: left;
    .avatar {
        @include breakpoints.desktop {
            margin: 6% 0px;
        }
    }
    @include breakpoints.desktop {
        width: 20%;
        margin: 6% 0px;
        padding-left: 10px;
    }
    @include breakpoints.desktop-medium {
        width: 20%;
        margin: 6% 0px;
        padding-left: 10px;
    }
    @include breakpoints.desktop-large {
        width: 15%;
        margin: 6% 0px;
        padding-left: 10px;
    }
  }
  
.contentRightV2 {
    width: 80%;
    float: left;
    margin-left: 12px;
    @include breakpoints.desktop {
        width:80%;
        margin: 4% 0px;
    }
}

.patientProfileV2 {
    img {
        width:35px;
        height: 35px;
        @include breakpoints.desktop {
            width: auto;
            height: auto;
        }
    }
}

.buttonContainerV2 {
    text-align: center;
    margin-top: 20px;
    button {
        border: 2px solid var(--blue-01);
        width: 90%;
        letter-spacing: 0.12em;
        font-size: 20px;
        @include breakpoints.desktop {
            width: 100%;
            font-size: 1.125rem;
        }
    }
}

.patientDetails {
    margin-left: 8px;
    padding: 4px 0;
    @include breakpoints.desktop {
        margin:2% 0;
        padding: 0;
    }
}
